import { BookingPermissions } from '@guiker/base-entity'
export { BookingPermissions as BookingActions }
